import {
  Box,
  Button,
  chakra,
  Checkbox,
  Flex,
  IconButton,
  shouldForwardProp,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { COMMON_WEB_PATH } from "../../constant";
import { isValidMotionProp, motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import Cookies from "js-cookie";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const LineCustomerModal = () => {
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { register_type } = isMemberInfo || {};

  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);

  const isLine = useMemo(() => {
    return register_type === "Line";
  }, [register_type]);

  const handleChecked = (e) => {
    setChecked(e.target.checked);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDirectToLine = () => {
    const line_url = "https://line.me/R/ti/p/@004iccrr";
    if (checked) {
      Cookies.set("dont_show_line_modal", "1", { expires: 365 });
    }
    window.location.href = line_url;
  };

  useEffect(() => {
    if (isLine) {
      setOpen(true);
    }
  }, [isLine]);

  return open && Cookies.get("dont_show_line_modal") != 1 ? (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="9999"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="85%"
        maxWidth={"520px"}
        h="auto"
        maxHeight={"480px"}
        position={"relative"}
        sx={{
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgImage: `url('${COMMON_WEB_PATH}/911TW/hintBG2.webp')`,
            bgPosition: "center",
            bgRepeat: "no-repeat",
            bgSize: "100% 100%",
            zIndex: 0,
          },
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgImage: `url('${COMMON_WEB_PATH}/911TW/getRealFrame.gif')`, //會動的框框gif
            bgPosition: "center",
            bgRepeat: "no-repeat",
            bgSize: "100% 100%",
            zIndex: 1,
            margin: "10px",
          },
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        //   justifyContent="space-between"
        p={6}
        pt="157px"
      >
        <Box position="absolute" top="-12%" right="10px" zIndex="3">
          <IconButton onClick={handleClose} fontSize="40px">
            <IoClose />
          </IconButton>
        </Box>
        {/* LINE背景 */}
        <Stack
          position="absolute"
          zIndex="2"
          top="-5%"
          left="50%"
          w={"260px"}
          transform="translateX(-50%)"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <img
            src={`${COMMON_WEB_PATH}/911TW/modal_LINE_banner.png`}
            alt="line"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Stack>

        {/* LINE文字 */}
        <Box
          display="flex"
          alignItems={"center"}
          justifyContent={"center"}
          position="relative"
          h="150px"
        >
          <Text
            color="white"
            fontSize="30px"
            textShadow={"#9c72b1 1px 0 11px"}
            fontWeight={"700"}
          >
            911LINE官方帳號
          </Text>
        </Box>

        {/* 雷射線 */}
        <Box
          position="relative"
          backgroundImage={`url('${COMMON_WEB_PATH}/911TW/modal_beam.png')`}
          w="100%"
          h="5px"
        />

        <Box
          my="10px"
          zIndex={3}
          cursor="pointer"
          position="relative"
          onClick={handleDirectToLine}
          as={Button}
          _hover={{
            bg: `url('${COMMON_WEB_PATH}/911TW/modal_button.png')`,
          }}
          w="229px"
          h="76px"
          bgRepeat={"no-repeat"}
          background={`url('${COMMON_WEB_PATH}/911TW/modal_button.png')`}
        ></Box>

        <Box
          position="relative"
          backgroundImage={`url('${COMMON_WEB_PATH}/911TW/modal_beam.png')`}
          w="100%"
          h="5px"
        />
        <Stack
          position="relative"
          alignItems={"center"}
          justifyContent={"center"}
          h="40px"
        >
          <Checkbox
            colorScheme="purple"
            size="lg"
            onChange={handleChecked}
            zIndex={3}
            checked={checked}
            sx={{
              background:
                "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
              fontSize: "20px",
              fontWeight: 700,
            }}
          >
            不再顯示
          </Checkbox>
        </Stack>
      </ChakraBox>
    </Flex>
  ) : null;
};

export default LineCustomerModal;
